import Yup, { generateAddressValidation } from '../yup';

const child = () =>
  Yup.object().shape({
    child_action: Yup.string()
      .required('Child action is required')
      .oneOf(['add', 'remove'], 'Child action must be either add or remove'),
    prp_giv_nam: Yup.string()
      .trim()
      .csvGivenName(true) // This allows spaces, but only in EVR applications
      .required("Child's first name is required"),
    prp_giv_nam2: Yup.string().trim(),
    prp_fam_nam: Yup.string()
      .trim()
      .required("Child's last name is required"),
    prp_dob: Yup.string()
      .trim()
      .when('child_action', {
        is: 'add',
        then: Yup.string()
          .csvDobUnder18()
          .csvDate('Invalid date', true)
          .required("Child's date of birth is required"),
        otherwise: Yup.string()
          .csvDatePast()
          .csvDate('Invalid date', true)
          .required("Child's date of birth is required"),
      }),
    prp_live: Yup.string().when('child_action', {
      is: 'add',
      then: Yup.string().required('Please select where the child is living'),
      otherwise: Yup.string(),
    }),
    ...generateAddressValidation('prp_addr', 'prp_live', 'no'),
    prp_rel_to_appl: Yup.string().when('child_action', {
      is: 'add',
      then: Yup.string().required(
        "Please select the child's relationship to you"
      ),
      otherwise: Yup.string(),
    }),
    prp_rel_to_appl_other: Yup.string().when('prp_rel_to_appl', {
      is: 'O',
      then: Yup.string().when('child_action', {
        is: 'add',
        then: Yup.string().required(
          "Please specify the child's relationship to you"
        ),
        otherwise: Yup.string(),
      }),
    }),
    prp_rel_to_resp: Yup.string().when('child_action', {
      is: 'add',
      then: Yup.string().required(
        "Please select the child's relationship to the respondent"
      ),
      otherwise: Yup.string(),
    }),
    prp_rel_to_resp_other: Yup.string().when('prp_rel_to_resp', {
      is: 'O',
      then: Yup.string().when('child_action', {
        is: 'add',
        then: Yup.string().required(
          "Please specify the child's relationship to the respondent"
        ),
        otherwise: Yup.string(),
      }),
    }),
    prp_sex1: Yup.string()
      .trim()
      .when('child_action', {
        is: 'add',
        then: Yup.string().required("Child's gender is required"),
        otherwise: Yup.string(),
      }),
    prp_sex_other: Yup.string().when('prp_sex1', {
      is: 'U',
      then: Yup.string().when('child_action', {
        is: 'add',
        then: Yup.string().required("Child's gender is required"),
        otherwise: Yup.string(),
      }),
    }),
    prp_abor_code: Yup.string().when('child_action', {
      is: 'add',
      then: Yup.string().required(
        'Please indicate if child is of Aboriginal and/or Torres Strait Islander background'
      ),
      otherwise: Yup.string(),
    }),
    prp_disabl: Yup.string().when('child_action', {
      is: 'add',
      then: Yup.string().required(
        'Please indicate if the child has a disability'
      ),
      otherwise: Yup.string(),
    }),
    prp_ord_exist: Yup.string().when('child_action', {
      is: 'add',
      then: Yup.string().required(
        'Please indicate if there any Family Law Act orders or Child Protection orders for this child'
      ),
      otherwise: Yup.string(),
    }),
  });

export default child;
